// Enforce MOQ step: if value is set above 0, snap to nearest valid multiple of moq_min
document.addEventListener('change', function(e) {
  const input = e.target;
  if (!input.classList.contains('quantity__input')) return;

  const rawMin  = parseInt(input.dataset.min  || '1', 10);
  const rawStep = parseInt(input.dataset.step || input.step || '1', 10);
  const val     = parseInt(input.value        || '0', 10);

  // Allow 0 (remove from cart)
  if (val === 0) return;

  // If below moq_min, snap up to moq_min
  if (val < rawMin) {
    input.value = rawMin;
    input.dispatchEvent(new Event('change', { bubbles: true }));
    return;
  }

  // Snap to nearest valid multiple: moq_min + (n * step)
  if (rawStep > 1) {
    const offset   = val - rawMin;
    const snapped  = Math.round(offset / rawStep) * rawStep;
    const newVal   = rawMin + snapped;
    if (newVal !== val) {
      input.value = newVal;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
});

// Cart page MOQ step enforcement - event delegation (survives AJAX re-render)
document.addEventListener('click', function(e) {
  const button = e.target.closest('.cart-quantity [name="plus"], .cart-quantity [name="minus"]');
  if (!button) return;

  const wrapper = button.closest('quantity-input');
  if (!wrapper) return;

  const input = wrapper.querySelector('input[data-step]');
  if (!input) return;

  const step = parseInt(input.dataset.step) || 1;
  const min = parseInt(input.dataset.min) || 1;

  if (step <= 1) return; // No MOQ, skip

  e.stopImmediatePropagation();

  const current = parseInt(input.value) || min;

  if (button.name === 'plus') {
    input.value = current + step;
  } else {
    const newVal = current - step;
    input.value = newVal < min ? min : newVal;
  }

  input.dispatchEvent(new Event('change', { bubbles: true }));
}, true); // capture phase